import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { getSettingOpenWithFaireOfferedTerms } from "@faire/retailer-visitor-shared/settings/getSettingOpenWithFaireOfferedTerms";
import { useOpenWithFaireApplicationStatus } from "@faire/retailer-visitor-shared/stores/domain/OpenWithFaire/useOpenWithFaireApplicationStatus";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { CurrencyUnit } from "@faire/web-api--source/faire/currency/CurrencyUnit";
import { IFaireMoney } from "@faire/web-api--source/indigofair/data/IFaireMoney";
import { IOpenWithFaireCreditOfferRange } from "@faire/web-api--source/indigofair/data/IOpenWithFaireCreditOfferRange";
import { IRetailer } from "@faire/web-api--source/indigofair/data/IRetailer";
var DEFAULT_TERMS_LIMIT_RANGE = IOpenWithFaireCreditOfferRange.build({
    min_terms_offered: IFaireMoney.build({
        amount_cents: 500000,
        currency: CurrencyUnit.USD
    }),
    medium_terms_offered: IFaireMoney.build({
        amount_cents: 1000000,
        currency: CurrencyUnit.USD
    }),
    max_terms_offered: IFaireMoney.build({
        amount_cents: 2000000,
        currency: CurrencyUnit.USD
    })
});
export var useOpenWithFaireTerms = function() {
    var _getSettingOpenWithFaireOfferedTerms;
    var retailer = useRetailer().retailer;
    var isRetailerOnNetTerms = useRetailerStore([
        "isRetailerOnNetTerms"
    ]).isRetailerOnNetTerms;
    var isEligible = useOpenWithFaireApplicationStatus().isEligible;
    var _retailer_business_category;
    var businessType = (_retailer_business_category = retailer === null || retailer === void 0 ? void 0 : retailer.business_category) !== null && _retailer_business_category !== void 0 ? _retailer_business_category : IRetailer.BusinessCategory.BRICK_AND_MORTAR;
    var _getSettingOpenWithFaireOfferedTerms_businessType;
    var offeredTermsRange = (_getSettingOpenWithFaireOfferedTerms_businessType = (_getSettingOpenWithFaireOfferedTerms = getSettingOpenWithFaireOfferedTerms()) === null || _getSettingOpenWithFaireOfferedTerms === void 0 ? void 0 : _getSettingOpenWithFaireOfferedTerms[businessType]) !== null && _getSettingOpenWithFaireOfferedTerms_businessType !== void 0 ? _getSettingOpenWithFaireOfferedTerms_businessType : DEFAULT_TERMS_LIMIT_RANGE;
    var _offeredTermsRange_min_terms_offered, _offeredTermsRange_medium_terms_offered, _offeredTermsRange_max_terms_offered;
    return {
        offeredMinTerms: (_offeredTermsRange_min_terms_offered = offeredTermsRange.min_terms_offered) !== null && _offeredTermsRange_min_terms_offered !== void 0 ? _offeredTermsRange_min_terms_offered : DEFAULT_TERMS_LIMIT_RANGE.min_terms_offered,
        offeredMediumTerms: (_offeredTermsRange_medium_terms_offered = offeredTermsRange.medium_terms_offered) !== null && _offeredTermsRange_medium_terms_offered !== void 0 ? _offeredTermsRange_medium_terms_offered : DEFAULT_TERMS_LIMIT_RANGE.medium_terms_offered,
        offeredMaxTerms: (_offeredTermsRange_max_terms_offered = offeredTermsRange.max_terms_offered) !== null && _offeredTermsRange_max_terms_offered !== void 0 ? _offeredTermsRange_max_terms_offered : DEFAULT_TERMS_LIMIT_RANGE.max_terms_offered,
        isEligibleWithNoInitialTerms: isEligible && !isRetailerOnNetTerms
    };
};
